module.exports = __webpack_public_path__ + "static/media/fermer-cercle.2037295f.png";